import { render, staticRenderFns } from "./ManagerStatistics.vue?vue&type=template&id=2936bf21&scoped=true"
import script from "./ManagerStatistics.vue?vue&type=script&lang=ts"
export * from "./ManagerStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936bf21",
  null
  
)

export default component.exports